import React from 'react'
import Link from 'gatsby-link'

const CustomerQuote = () => (
    <section className="large-quote-section">
        <div className="container has-text-centered">
            <p className="is-size-4 has-text-weight-semi-bold">"I especially liked the bourbon tasting/survey game, it felt like we all came together and opened up a little
more after that point." - Nicole H. </p>
        </div>
    </section>
)

export default CustomerQuote


// WEBPACK FOOTER //
// ./src/components/customerQuote.js